export const useSuggestions = () => {
  const sanctumFetch = useSanctumClient();

  const fetching = ref(false);

  const index = async () => {
    fetching.value = true;

    const response = await sanctumFetch("/suggestions", {
      query: {
        limit: 5,
      },
    });

    fetching.value = false;

    return response.data;
  };

  return {
    fetching,
    index,
  };
};
